<div class="lum-page lum-page__card lum-c-app-integration-accounts">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading || false"
    [classes]="'loading'"
  ></div>

  <header class="lum-page-header lum-page-header--sticky">
    <div class="lum-page-header__heading">
      <a routerLink="/settings/system">System Settings</a> /
      <h2>App Integration Accounts</h2>
    </div>
    <div class="lum-page-header__actions">
      <button
        class="lum-button lum-button--primary lum-button--medium"
        (click)="onOpenFormModal()"
      >
        New App Account
      </button>
    </div>
  </header>

  <div class="lum-page-content">
    <div class="lum-page-content__tools">
      <input
        type="text"
        class="lum-input w-80"
        placeholder="Search label..."
        matInput
        lumDebounceTime
        (debounceValue)="onFilterChange($event)"
      />
    </div>

    <div class="lum-c-app-integration-accounts__table">
      <table class="lum-table lum-table--classic striped">
        <thead>
          <tr>
            <th>Label</th>
            <th>App</th>
            <th>Has Credentials</th>
            <th>Status</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let account of appIntegrationAccounts$ | async">
            <tr>
              <td>
                {{ account.label }}
              </td>
              <td>
                {{ account.app }}
              </td>
              <td>
                <span class="text-success" *ngIf="account.hasCredentials">
                  YES
                </span>
                <span class="text-warning" *ngIf="!account.hasCredentials">
                  NO
                </span>
              </td>
              <td>
                <i
                  class="fa fa-exclamation-triangle text-yellow-600 pr-2"
                  *ngIf="account.isStaleActivity"
                  matTooltip="No recent activity in over 30 days"
                ></i>
                <ng-container *ngIf="account.channelIntegrationTransactions?.length; else noActivity">
                  <span
                    (click)="onViewTimelineList(account.channelIntegrationTransactions)"
                    [ngClass]="{
                      'text-danger cursor-pointer': account.channelIntegrationTransactions[0]?.status === channelIntegrationStatusConstant.FAILED,
                      'text-success cursor-pointer': account.channelIntegrationTransactions[0]?.status === channelIntegrationStatusConstant.SUCCESS
                    }"
                  >
                    <span>
                      ({{ account.channelIntegrationTransactions[0]?.updatedAt | date: 'MMM d, y, h:mm a' }})
                      {{ account.channelIntegrationTransactions[0]?.status }}<ng-container *ngIf="(account.channelIntegrationTransactions[0]?.metadata | parseJsonString: 'operation') as operation">: {{ operation }}</ng-container>
                    </span>
                    <ng-container *ngIf="account.channelIntegrationTransactions[0]?.status === channelIntegrationStatusConstant.FAILED">
                      - {{
                        (account.channelIntegrationTransactions[0]?.response | parseJsonString: 'message') | slice: 0:48
                      }}{{ (account.channelIntegrationTransactions[0]?.response | parseJsonString: 'message')?.length > 48 ? '…' : '' }}
                    </ng-container>
                  </span>
                </ng-container>
                <ng-template #noActivity>
                  <span class="text-muted">No activity yet</span>
                </ng-template>
              </td>

              <td class="text-right">
                <button class="btn" type="button" [matMenuTriggerFor]="menu">
                  <i class="flaticon-more"></i>
                </button>
              </td>

              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onEditAccount(account)">
                  Edit
                </button>
                <button mat-menu-item (click)="onDeleteAccount(account)">
                  Delete
                </button>

                <button
                  mat-menu-item
                  (click)="onAuthorizeAccount(account)"
                  *ngIf="account.showConnectStore"
                >
                  Connect Store
                </button>

                <a
                  *ngIf="TemplateHelper.canManageProducts(account)"
                  mat-menu-item
                  [routerLink]="
                    '/settings/app-integration-account-settings/' +
                    account.id +
                    '/manage/products'
                  "
                  >Manage Products</a
                >
                <a
                  *ngIf="TemplateHelper.canManageCompanies(account)"
                  mat-menu-item
                  [routerLink]="
                    '/settings/app-integration-account-settings/' +
                    account.id +
                    '/manage/companies'
                  "
                  >Manage Companies</a
                >
              </mat-menu>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <mat-paginator
        class="mr-12"
        [length]="pagination.total || 0"
        [pageSize]="pagination.per_page || paginationConfig.perPage"
        [pageSizeOptions]="paginationConfig.pageSizeOptions"
        [pageIndex]="(pagination.current_page || 1) - 1"
        (page)="onPaginationEvent($event)"
        aria-label="Select page"
      ></mat-paginator>
    </div>
  </div>
</div>
